import React from 'react';
import { Link, useTheme } from '@mui/material';

const SkipLink: React.FC = () => {
  const theme = useTheme();

  return (
    <Link
      href="#main-content"
      sx={{
        position: 'absolute',
        top: -40,
        left: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        padding: theme.spacing(1, 2),
        textDecoration: 'none',
        borderRadius: theme.shape.borderRadius,
        zIndex: theme.zIndex.tooltip,
        fontWeight: 500,
        '&:focus': {
          top: theme.spacing(1),
        },
        transition: theme.transitions.create(['top'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.short,
        }),
      }}
    >
      Skip to main content
    </Link>
  );
};

export default SkipLink;